import { EXTRACTION_START } from '../../consts/actionTypes';

export const extractionAction = (data, endPoint) => ({
    type: EXTRACTION_START,
    data,
    endPoint,
});
